import { TRYON_SERVER_URL } from "../../config";

/**
 * Fetch user onboarding status from server
 * @param {string} accessToken - User's access token
 * @returns {Promise<Object>} - Onboarding data or empty array if not completed
 */
export const fetchUserOnboardingStatus = async (accessToken) => {
  try {
    const response = await fetch(`${TRYON_SERVER_URL}/api/v1/user/onboarding/`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const data = await response.json();
      return {
        status: "success",
        data: data,
        isCompleted: Array.isArray(data) && data.length > 0,
      };
    } else {
      return {
        status: "error",
        message: "Failed to fetch onboarding status",
        isCompleted: false,
      };
    }
  } catch (error) {
    console.error("Error fetching onboarding status:", error);
    return {
      status: "error",
      message: error.message || "Network error",
      isCompleted: false,
    };
  }
};

/**
 * Update user onboarding data
 * @param {string} accessToken - User's access token
 * @param {Array} onboardingData - Array of onboarding steps with values
 * @returns {Promise<Object>} - Response status
 */
export const updateUserOnboardingData = async (accessToken, onboardingData) => {
  try {
    const response = await fetch(`${TRYON_SERVER_URL}/api/v1/user/onboarding/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(onboardingData),
    });

    if (response.ok) {
      const data = await response.json();
      return {
        status: "success",
        data: data,
      };
    } else {
      const errorData = await response.json().catch(() => ({}));
      return {
        status: "error",
        message: errorData.message || "Failed to update onboarding data",
      };
    }
  } catch (error) {
    console.error("Error updating onboarding data:", error);
    return {
      status: "error",
      message: error.message || "Network error",
    };
  }
};

/**
 * Format onboarding data for API submission
 * @param {Object} formData - Form data object with step IDs as keys
 * @returns {Array} - Formatted array for API
 */
export const formatOnboardingData = (formData) => {
  return Object.entries(formData).map(([stepId, value]) => {
    // Handle multi-select values
    const onboardingValue = Array.isArray(value) ? value.join(", ") : value;
    
    return {
      onboarding_step: stepId,
      onboarding_value: onboardingValue,
    };
  });
};

